// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const CirclePositioner = require('client-v2/common/components/circle-positioner')
const LazyImage = require('client-v2/common/components/lazy-image')
const PopperAnchor = require('client-v2/common/components/popper-anchor')
const Icon = require('client-v2/common/containers/icons/component')
const { userProfileHref } = require('client-v2/common/models/user/actions')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('UserAvatar')

function UserAvatar(props) {
  // Props
  const photoUrl = props.user['photo_url']
  let href = props.href || undefined
  if (props.href === true) {
    href = userProfileHref(props.user)
  }
  let badgeId
  let badgeTooltip
  if (props.badge !== false) {
    if (props.user.isVerifiedCurator) {
      badgeId = 'verified-curator'
      badgeTooltip = 'Verified Curator'
    }
  }
  // Hooks
  const [ isHoveringOnBadge, setHoveringOnBadge ] = React.useState(false)
  const onMouseEnterBadge = React.useCallback(
    () => { setHoveringOnBadge(true) },
    [ setHoveringOnBadge ]
  )
  const onMouseLeaveBadge = React.useCallback(
    () => { setHoveringOnBadge(false) },
    [ setHoveringOnBadge ]
  )
  const renderPopper = React.useCallback(
    popperProps => (
      tag('div', {
        ref: popperProps.ref,
        className: bem.element('badge-tooltip'),
        style: popperProps.style
      },
        badgeTooltip
      )
    ),
    [ badgeTooltip ]
  )
  // Render
  return (
    tag('div', {
      ref: props.forwardedRef,
      className: classNames(
        props.className,
        bem.block()
      ),
      style: props.style
    },
      tag(LazyImage, {
        className: bem.element('image'),
        href,
        title: props.title || `${props.user.username}'s Profile`,
        sources: [ photoUrl ],
        visible: props.visible,
        onClick: props.onClick
      }),
      badgeId && (
        tag(CirclePositioner, {
          className: bem.element('badge-positioner')
        },
          tag(PopperAnchor, {
            isDisabled: !isHoveringOnBadge,
            placement: 'bottom',
            portalContainer: '#modal-root',
            renderPopper
          },
            tag(Icon, {
              className: bem.element('badge'),
              id: badgeId,
              onMouseEnter: onMouseEnterBadge,
              onMouseLeave: onMouseLeaveBadge
            })
          )
        )
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const morePropTypes = require('client-v2/common/utils/prop-types')

  UserAvatar.propTypes = {
    forwardedRef: morePropTypes.domRef,
    // Values
    badge: PropTypes.bool,
    className: PropTypes.string,
    href: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    user: PropTypes.shape({
      // Works for collections too!
      isVerifiedCurator: PropTypes.bool,
      'photo_url': PropTypes.string.isRequired,
      username: PropTypes.string.isRequired
    }),
    title: PropTypes.string,
    visible: PropTypes.bool,
    // Callbacks
    onClick: PropTypes.func
  }
}

module.exports = UserAvatar
